module.exports = __webpack_public_path__ + "a80588a45df7c89b824e37687abb8a3c.jpg";